<template>
    <div>
        <div class="bg">
            <div class="sub-title">Products</div>
            <div class="title">产品总成</div>
        </div>
        <div>
            <div class="m-3" >
                <div>
                    <div class="text-center title">{{ info.fJ_ProductAssemblyInfo!=null?info.fJ_ProductAssemblyInfo.productName:"" }}</div>
                    <div class="text-center" style="margin-top: 10px;">{{info.fJ_ProductAssemblyInfo!=null?info.fJ_ProductAssemblyInfo.productNameEN:""  }}</div>
                </div>
                <div class="mt-3">
                    <!--  <img src="../../assets/img/banner-02.jpg" style="width: 100%;" alt="">-->
                    <div class="bgg">

                        <img :ref="prefix+info.fJ_ProductAssemblyInfo.id" :src="http.ipAddress+info.fJ_ProductAssemblyInfo.filePath"
                        style="width: 100%;" alt="" >
                        
                    </div>
                </div>


                <div class="mt-1 flex-row flex-wrap justify-between">
                    <div @click="page(item.productType,item.id)" class="product-item" v-for="(item,index) in info.fJ_Products">
                        <div class="product-img flex-row align-center justify-center">
                            <img :src="http.ipAddress+item.filePath" style="width: 150px;" alt="">
                        </div>
                        <div class="text-center mt-1 ">{{item.productName}}</div>
                    </div>
                </div>

                
              

            </div>
        </div>
    </div>
</template>

<script>
// import { controllerData,  meterData} from "../products/products";
export default {
    data() {
        return {
            prefix:"product",
            switch:1,
            info:{}
        }
    },
    methods: {
        page(switchValue,index) {
            debugger
            if(switchValue==3){
                this.$router.push({path:'/productAssembly', query: {index}});
            }else{
                this.$router.push({path:'/productsDetail', query: {switch:switchValue,index}});
            }
           
        }
    },
    mounted() {
        debugger
        let index =  this.$route.query.index;
        let that=this;
        this.http.post("/api/FJ_ProductInfo/GetProductInfoAssembly",JSON.stringify({productid:parseInt(index,10),lanuage:0})).then((result)=>{
            debugger
           let objResult= eval(result);
           let iCode= objResult.code;
           if(iCode==0){
            that.info=objResult.data;
               // that.refs.product10.focus();
               // document.getElementById("product10").focus();

            }
        });



        
    }
}
</script>

<style scoped>
.bg {
    background: url('../../assets/img/productbanner.jpg') no-repeat;
    background-size: 100% ;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.m-3 {
    margin: 30px;
}
.product-item {
    width: 48%;
    margin-bottom: 10px;
    border: 1px solid #ffffff
}

.border {
    border-top: 1px solid #eee;
    padding: 5px 0;
}

.product-img {
    background-color: #eee;
    width: 100%;
    height: 100px;
}
.video {
    background-color: #00585252;
    height: 200px;
    width: 100%;
}

.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}

.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}

.mt-1 {
    margin-top: 10px;
}

.mt-3 {
    margin-top: 30px;
}

.border {
    margin-top: 30px;
    /* padding-top: 30px; */
    border-top: 1px solid #eee;
}

.ttitle1 {
    font-size: 16px;
    font-weight: 700;
    line-height: 30px;
}

.pp {
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/views/products/m_assembly.vue